function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowW16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 802",
  style: {
    opacity: 0.5
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 799",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m259.893 20.818 5.872 5.872-5.872 5.872",
  "data-name": "Path 480",
  style: {
    fill: "none",
    stroke: "#9d9d9d",
    strokeLinejoin: "round"
  },
  transform: "translate(-254 -19)"
})));
export default SvgIconArrowW16;